import { Asterisk } from "lucide-react";

const ITEMS = [
  "La libertà si costruisce una procedura alla volta",
  "Delega senza ansia",
  "Organizza il tuo lavoro",
  "Tempo per te e per chi ami",
  "Meno urgenze, più vita",
  "La tua attività cresce, anche senza di te",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee-section" className="overflow-hidden border-y border-ink/10 bg-terracotta py-5">
      <div className="flex w-max animate-marquee items-center gap-8 pr-8">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 whitespace-nowrap">
            <span className="font-serif text-lg italic text-linen sm:text-xl">{item}</span>
            <Asterisk className="h-5 w-5 text-linen/60" />
          </span>
        ))}
      </div>
    </section>
  );
};
